import { FC } from "react";
import useLocales from "../../hooks/useLocales";

interface Props {
  data: string | number;
}

const DateField: FC<Props> = ({ data }) => {
  const { currentLang } = useLocales();
  const record = new Date(data).toLocaleDateString(currentLang.value);
  return <div>{record} </div>;
};

export default DateField;
